<mat-card>
  <h2 translate>{{ title }}</h2>
  <p translate>{{ subtitle }}</p>
  <mat-card-content>
    <form [formGroup]="commonForm" (ngSubmit)="consult()">
      <div fxFlex fxLayout="row wrap" class="form-wrapper">
        <div fxFlex="100" fxFlex.gt-sm="50" *ngIf="isMacroChainUser || isBusinessDirector">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="macroChain"
            [cucumberId]="'macroChain'"
            [id]="'macroChainSelect'"
            [dataInput]="macroChainList"
            [placeholder]="'macrouser.title.groups'"
            [isRequired]="true"
            [showErrors]="commonForm?.controls?.macroChain?.errors"
          >
          </scf-custom-select-search>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="50" *ngIf="isMacroOfficeUser || isBusinessDirector">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="macroOffice"
            [cucumberId]="'macroOffice'"
            [id]="'macroOfficeSelect'"
            [dataInput]="macroOfficeList"
            [placeholder]="'macrouser.title.offices'"
            [isRequired]="true"
            [showErrors]="commonForm?.controls?.macroOffice?.errors"
          >
          </scf-custom-select-search>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="100" *ngIf="isMacroChainUser || isMacroOfficeUser"></div>
        <!--START DATEPICKERS-->
        <div fxFlex="50" fxFlex.gt-sm="30">
          <mat-form-field fxFlex="100" appearance="outline" monthYearFullDirective>
            <mat-label translate>commonForm.initialDate</mat-label>
            <input
              #inputInitialDate
              [attr.data-cucumber-id]="'initialDate'"
              id="initialDateInput"
              matInput
              [matDatepicker]="datepickerInitialDate"
              formControlName="initialDate"
              [max]="maxDate"
              autocomplete="off"
            />
            <mat-datepicker-toggle matSuffix [for]="datepickerInitialDate"></mat-datepicker-toggle>
            <mat-datepicker
              [attr.data-cucumber-id]="'initialDatePicker'"
              id="initialDateDatepicker"
              startView="multi-year"
              #datepickerInitialDate
              (monthSelected)="chosenMonthHandler($event, datepickerInitialDate, inputInitialDate)"
              (yearSelected)="chosenYearHandler($event, inputInitialDate)"
            ></mat-datepicker>
            <mat-error *ngIf="commonForm.controls.initialDate.hasError('required')" translate>
              field.required
            </mat-error>
            <mat-error *ngIf="commonForm.controls.initialDate.errors?.dateFuture" translate>
              field.error.dateFuture
            </mat-error>
            <mat-error *ngIf="commonForm.errors?.dateInvalid" translate>field.error.dateInitial</mat-error>
          </mat-form-field>
        </div>

        <div fxFlex="50" fxFlex.gt-sm="30">
          <mat-form-field fxFlex="100" appearance="outline" monthYearFullDirective>
            <mat-label translate>commonForm.finalDate</mat-label>
            <input
              #inputFinalDate
              [attr.data-cucumber-id]="'finalDate'"
              id="finalDateInput"
              matInput
              [matDatepicker]="datepickerFinalDate"
              formControlName="finalDate"
              [min]="minDate"
              [max]="maxFinalDate"
              autocomplete="off"
            />
            <mat-datepicker-toggle matSuffix [for]="datepickerFinalDate"></mat-datepicker-toggle>
            <mat-datepicker
              [attr.data-cucumber-id]="'finalDatePicker'"
              id="finalDateDatepicker"
              startView="multi-year"
              #datepickerFinalDate
              (monthSelected)="chosenMonthHandler($event, datepickerFinalDate, inputFinalDate)"
              (yearSelected)="chosenYearHandler($event, inputFinalDate)"
            ></mat-datepicker>
            <mat-error *ngIf="commonForm.controls.finalDate.hasError('required')" translate> field.required </mat-error>
            <mat-error *ngIf="commonForm.controls.finalDate.hasError('matDatepickerMin')" translate
              >field.error.dateFinal</mat-error
            >
            <mat-error *ngIf="commonForm.controls.finalDate.errors?.dateFuture" translate>
              field.error.dateFuture
            </mat-error>
            <mat-error *ngIf="commonForm.errors?.dateYearError" translate>field.notMoreThanAYear</mat-error>
          </mat-form-field>
        </div>

        <!--END DATEPICKERS-->
        <!--START DIVISION-->
        <div fxFlex="50" fxFlex.gt-sm="40">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="division"
            [cucumberId]="'division'"
            [id]="'divisionSelect'"
            [dataInput]="divisionList"
            [placeholder]="'commonForm.division'"
            [isRequired]="true"
            [showErrors]="commonForm?.controls?.division?.errors"
          >
          </scf-custom-select-search>
        </div>
        <!--END DIVISION-->

        <!--START OFICINA-->
        <div fxFlex="50" fxFlex.gt-sm="30">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="office"
            [cucumberId]="'office'"
            [id]="'officeSelect'"
            [dataInput]="officeList"
            [placeholder]="'commonForm.office'"
            [showErrors]="commonForm?.controls?.office?.errors"
          >
          </scf-custom-select-search>
        </div>
        <!--END OFICINA-->

        <!--START PRODUCTO-->
        <div fxFlex="100" fxFlex.gt-sm="30">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="product"
            [cucumberId]="'product'"
            [id]="'productSelect'"
            [dataInput]="productList"
            [placeholder]="'commonForm.product'"
            [showErrors]="commonForm?.controls?.product?.errors"
          >
          </scf-custom-select-search>
        </div>
        <!--END PRODUCTO-->

        <!--START TIPO BIEN-->
        <div fxFlex="100" fxFlex.gt-sm="40">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="typeProperty"
            [cucumberId]="'article'"
            [id]="'typePropertySelect'"
            [dataInput]="articlesList"
            [placeholder]="'commonForm.typeProperty'"
            [showErrors]="commonForm?.controls?.typeProperty?.errors"
          >
          </scf-custom-select-search>
        </div>
        <!--END TIPO BIEN-->

        <div fxFlex="100" fxFlex.gt-sm="100">
          <div class="search-operation-detail__button">
            <button
              id="searchButtonOperationDetail"
              color="accent"
              type="submit"
              mat-flat-button
              [disabled]="commonForm.invalid"
            >
              <mat-label>{{ 'commonForm.button' | translate | uppercase }}</mat-label>
            </button>
          </div>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>
